import { createActions } from '../utils/actions';

const { actions: affiliate } = createActions('affiliate')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('getHistory')
  .addAsync('getLink')
  .addAsync('getPayout')
  .addAsync('getPayoutMethod')
  .addAsync('sendApplicationSurvey')
  .add('setData')
  .addAsync('setPayoutMethod');

export default affiliate;
